import { Button } from '@design-system/button';
import { Link } from '@design-system/link';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import React, { FC } from 'react';

import { languageSwitchClassName } from '../../constants/constants';
import { useDropdown } from '../../hooks/useDropdown';
import { getLinkIcon } from '../../utils/getLinkIcon';
import { getLinkSize } from '../../utils/getLinkSize';
import { LanguageSwitchProps } from './models';

export const LanguageSwitch: FC<LanguageSwitchProps> = ({
  title,
  ariaLabel,
  languageData,
  linkNavElement: LinkElement = Link,
  openIcon,
  closeIcon,
  isMobileView,
}) => {
  const {
    handleDesktopBlur,
    handleDesktopOutsideBlur,
    handleFocus,
    handleShowMoreClick,
    handleKeyPress,
    isOpen,
    handleMouseOver,
  } = useDropdown();

  const onMouseOverDesktop = !isMobileView ? handleMouseOver : undefined;

  return (
    <li
      className={classNames(
        'cds-global-header__navigation-item',
        'cds-global-header__navigation-item--has-children',
        languageSwitchClassName
      )}
      onBlur={handleDesktopOutsideBlur}
      onMouseLeave={handleDesktopBlur}
    >
      <Button
        onKeyDown={handleKeyPress}
        onClick={handleShowMoreClick}
        onBlur={handleDesktopBlur}
        onMouseOver={onMouseOverDesktop}
        variant="nav"
        size={getLinkSize(isMobileView)}
        aria-label={ariaLabel}
        aria-expanded={isOpen}
        className={classNames('cds-global-header__lang-switch-btn', {
          active: isOpen,
        })}
        iconPrefix={{
          props: {
            icon: 'translation',
            className: 'cds-global-header__lang-switch-icon',
          },
        }}
        iconSuffix={getLinkIcon(openIcon, closeIcon, isOpen, !isMobileView)}
      >
        {title}
      </Button>
      {isMobileView ? (
        <Button
          variant="primary-icon"
          onClick={handleShowMoreClick}
          onKeyDown={handleKeyPress}
          size="small"
          className="cds-global-header__navigation-arrow"
          aria-expanded={isOpen}
          iconSuffix={getLinkIcon(openIcon, closeIcon, isOpen)}
        >
          {title}
        </Button>
      ) : null}
      <div className="cds-global-header__navigation-drop">
        <ul className="cds-global-header__lang-list">
          {languageData.map(({ label, href, locale, translated, ...item }) => (
            <li key={locale}>
              {translated ? (
                <LinkElement
                  className="cds-global-header__lang-link"
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...item}
                  href={href}
                  onClick={handleDesktopBlur}
                  variant="nav"
                  size={getLinkSize(isMobileView)}
                  onFocus={handleFocus}
                  onBlur={handleDesktopBlur}
                >
                  {label}
                </LinkElement>
              ) : (
                <Typography
                  className="cds-global-header__lang-item"
                  content={label}
                  tag="span"
                  variant="body"
                />
              )}
            </li>
          ))}
        </ul>
      </div>
    </li>
  );
};
